import { useApi } from '@/hooks/useApi';
import { useModeAwareMutation } from '@/hooks/useModeAwareQuery';
import { emailMergeDataDemoResponse } from '@/services/demo/email-merge-demo.service';

export interface EmailMergeRecipientRequest {
  recipientId: string;
  recipientEmail: string;
  customerId: number;
  contactId?: number;
  transactionIds?: number[];
}

export interface EmailMergeDataRequest {
  sourceType: string;
  sourceId?: number;
  templateId?: number;
  includeInvoiceDescription?: boolean;
  excludeCreditTransactions?: boolean;
  excludeDisputed?: boolean;
  subject?: string;
  body?: string;
  recipients: EmailMergeRecipientRequest[];
}

export interface EmailMergeRecipientResponse {
  recipientId: string;
  mergeData: Record<string, string>;
  mergeDataHtml?: Record<string, string>;
}

export interface PaymentLinkBelowMinimum {
  amount: number;
  currencyCode: string;
  description: string;
}

export interface EmailMergeDataResponse {
  recipients: EmailMergeRecipientResponse[];
  unknownPlaceholders: string[];
  emptyDataPlaceholders: string[];
  /** Set when the template used <<paymentlink>> but the case total is below the PaySuite minimum. */
  paymentLinkBelowMinimum?: PaymentLinkBelowMinimum | null;
}

export function useEmailMergeData() {
  const { apiPost } = useApi();

  return useModeAwareMutation<EmailMergeDataResponse, Error, EmailMergeDataRequest>(async (request) => {
    return apiPost<EmailMergeDataResponse>('/api/v1/email/merge-data', request);
  }, emailMergeDataDemoResponse);
}
